export default __webpack_public_path__ + "static/media/discord.2151829f.png";